import { useNavigate, useLocation } from "react-router-dom";
import Header from "../components/Header";

export default function Success() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get data passed from EnterPin
  const { data, amount, merchantAddress, cardId } = location.state || {};

  const handleDone = () => {
    navigate("/");
  };

  const truncateHash = (hash) => {
    if (!hash) return "****";
    return `${hash.slice(0, 10)}...${hash.slice(-8)}`;
  };

  const truncateAddress = (addr) => {
    if (!addr) return "****";
    return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
  };

  return (
    <div className="p-6 min-h-screen flex flex-col bg-gradient-to-b from-gray-900 to-gray-800 text-white">
      <Header />
      
      <div className="flex-1 flex flex-col items-center justify-center px-6 pb-12">
        {/* Success Icon */}
        <div className="mb-6">
          <div className="w-24 h-24 bg-green-500/20 rounded-full flex items-center justify-center border-4 border-green-500">
            <span className="text-6xl">✓</span>
          </div>
        </div>

        {/* Success Message */}
        <h1 className="text-3xl font-bold text-green-400 mb-2">
          Payment Successful!
        </h1>
        <p className="text-gray-400 text-center mb-8">
          Your transaction has been processed
        </p>

        {/* Transaction Details */}
        <div className="w-full max-w-md bg-gray-800 rounded-2xl p-6 mb-6">
          {/* Amount */}
          <div className="text-center mb-6 pb-6 border-b border-gray-700">
            <p className="text-gray-400 text-sm mb-2">Amount Paid</p>
            <p className="text-4xl font-bold text-green-400">
              ${parseFloat(amount || data?.data?.amount || 0).toFixed(2)}
            </p>
            <p className="text-gray-400 text-xs mt-1">MUSD</p>
          </div>

          {/* Card ID */}
          {(cardId || data?.data?.cardId) && (
            <div className="mb-4">
              <p className="text-gray-400 text-xs mb-1">Card ID</p>
              <p className="text-white font-mono text-sm">
                {cardId || data?.data?.cardId}
              </p>
            </div>
          )}

          {/* Merchant */}
          {(merchantAddress || data?.data?.merchant) && (
            <div className="mb-4">
              <p className="text-gray-400 text-xs mb-1">Merchant</p>
              <p className="text-green-400 font-mono text-sm">
                {truncateAddress(merchantAddress || data?.data?.merchant)}
              </p>
            </div>
          )}

          {/* Transaction Hash */}
          {(data?.data?.transactionHash || data?.transactionHash) && (
            <div className="mb-4">
              <p className="text-gray-400 text-xs mb-1">Transaction Hash</p>
              <p className="text-blue-400 font-mono text-xs break-all">
                {truncateHash(data?.data?.transactionHash || data?.transactionHash)}
              </p>
            </div>
          )}

          {/* Block Number */}
          {(data?.data?.blockNumber || data?.blockNumber) && (
            <div className="mb-4">
              <p className="text-gray-400 text-xs mb-1">Block Number</p>
              <p className="text-white font-mono text-sm">
                {data?.data?.blockNumber || data?.blockNumber}
              </p>
            </div>
          )}

          {/* New Balance */}
          {(data?.data?.newBalance || data?.newBalance) && (
            <div className="mb-4">
              <p className="text-gray-400 text-xs mb-1">Remaining Card Balance</p>
              <p className="text-white font-semibold text-lg">
                ${parseFloat(data?.data?.newBalance || data?.newBalance).toFixed(2)} MUSD
              </p>
            </div>
          )}

          {/* Timestamp */}
          {(data?.data?.timestamp || data?.timestamp) && (
            <div>
              <p className="text-gray-400 text-xs mb-1">Time</p>
              <p className="text-white text-sm">
                {new Date(data?.data?.timestamp || data?.timestamp).toLocaleString()}
              </p>
            </div>
          )}
        </div>

        {/* Action Buttons */}
        <div className="w-full max-w-md space-y-3">
          {/* Explorer Link */}
          {(data?.data?.explorerUrl || data?.explorerUrl) && (
          <a  
              href={data?.data?.explorerUrl || data?.explorerUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full bg-gray-700 hover:bg-gray-600 py-3 rounded-xl text-sm font-semibold transition text-center"
            >
              🔍 View on Explorer
            </a>
          )}

          {/* Done Button */}
          <button
            onClick={handleDone}
            className="w-full bg-blue-600 hover:bg-blue-700 py-4 rounded-xl text-lg font-semibold shadow-lg transition"
          >
            Done
          </button>
        </div>

        {/* Success Note */}
        <div className="mt-8 w-full max-w-md">
          <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4">
            <p className="text-green-200 text-xs text-center">
              💡 Transaction has been confirmed on the blockchain
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
